import { ReactElement, ReactNode } from "react";
import { Theatre } from "@ingka/modal";
import "@ingka/svg-icon/dist/style.css";
import "@ingka/button/dist/style.css";
import "@ingka/modal/dist/style.css";
import "@ingka/focus/dist/style.css";

interface TheatreProps {
  header: ReactElement | null;
  children: ReactNode;
  ariaLabel: string;
}

export const FixaTheatre = (props: TheatreProps) => {
  return <Theatre {...props} />;
};
